import React from 'react';

export default function IconTransferSaham() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_674_33382)">
        <path
          d="M4.625 8.14445L4.625 17.7345C4.625 18.469 5.22046 19.0645 5.955 19.0645H18.295C19.0295 19.0645 19.625 18.469 19.625 17.7345V8.14445C19.625 7.40991 19.0295 6.81445 18.295 6.81445H5.955C5.22046 6.81445 4.625 7.40991 4.625 8.14445Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.125 5.90195V6.81445H15.1175V5.90195C15.1175 5.16741 14.522 4.57195 13.7875 4.57195H10.455C9.72046 4.57195 9.125 5.16741 9.125 5.90195Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.375 11.8242C8.375 10.9992 9.05 10.3242 9.875 10.3242H15.875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.375 8.82422L15.875 10.3242L14.375 11.8242"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8301 14.0586C15.8301 14.8836 15.1551 15.5586 14.3301 15.5586H8.33008"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.83008 17.0586L8.33008 15.5586L9.83008 14.0586"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_674_33382">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3.125 3.06445)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
